// extracted by mini-css-extract-plugin
export default {"footerDesktop":"FooterStyle_footerDesktop__XpmTF","divWrapper":"FooterStyle_divWrapper__f75q1","brDisplay":"FooterStyle_brDisplay__r+wEB"};